import { navigate } from 'hookrouter';
import { seriesToRemove } from '../../components/charts/Settings';

//const login = "desenv2";
//const password = "desenv2";

const apiUrl = window.location.hostname === "10.20.19.4" ? 
                process.env.REACT_APP_API_URL_INTERNAL:
                    process.env.REACT_APP_API_URL_EXTERNAL;

const LoginBG = async (login, password) => {
	
    return await fetch(`${process.env.REACT_APP_API_URL}/api/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache' // Add this line
        },
        credentials: "include",
        mode: 'cors',
        body: `login=${login}&password=${password}`,
        cacheTime: 0
    })
}

const Logout = async () => {
    return await fetch(`${apiUrl}/api/logout`, {method: 'POST',  credentials: "include"}, {cacheTime: 0})
}


const ParametrosAnalise = async () => {
    return executar('api/parametrosAnaliseComUnidade')
}

const DadosSeriesAnaliseByIdParametroAnaliseComUnidade = async (parametroId) => {
    return executar(`api/dadosSeriesAnaliseByIdParametroAnaliseComUnidade?idParametroAnalise=${parametroId}`)
}

const Grids = async () => {
    return executar(`resources/layers/grids.geojson`)
}

const MicrobaciasSimplificada_000100 = function() {
    let cachedResponse = null;
    return async () => {
        if(!cachedResponse) {
            cachedResponse = await MicrobaciasSimplificada_000100_original();
        }
        // console.log(cachedResponse);
        return cachedResponse;
    };
}();

const MicrobaciasSimplificada_000100_original = async () => {
    return executar(`resources/layers/microbaciasSimplificada_000100.geojson`)
};

const MapAnalysesByAmostraTypeAndParametroAnaliseAndSerieAnalise = async (parametroAnaliseId, serieAnaliseId, constrastar) => {
    return executar(`mapAnalysesByParametroAnaliseAndSerieAnalise.json?parametroAnaliseId=${parametroAnaliseId}&serieAnaliseId=${serieAnaliseId}&contrastar=${constrastar}`)
}

const ChartsDataDistribution = async (parametroId, idSeries) => {
    //idSeries = [...(new Set(idSeries.map(serie => serie.serie)))]
    idSeries = [...(new Set(idSeries.map(serie => serie.serie)))].filter(function(value, index, arr){
        return (!seriesToRemove.includes(value))
    })
    //
    const series = idSeries.map(serie => `idSeries=${serie}`).join('&')
    return executar(`api/getBPData?idParam=${parametroId.id}&${series}`)
}

const ChartsDataCountSerieCampanha = async (parametroId, idSeries) => {
    //idSeries = [...(new Set(idSeries.map(serie => serie.serie)))]
    idSeries = [...(new Set(idSeries.map(serie => serie.serie)))].filter(function(value, index, arr){
        return (!seriesToRemove.includes(value))
    })
    //
    const series = idSeries.map(serie => `idSeries=${serie}`).join('&')
    return executar(`api/getCountByParametroSerie?idParam=${parametroId.id}&${series}`)
}

const LimiaresParaOsGraficos = async (parametroId, tipoAmostraIds, tipoLimiarIds) => {
    const limiaresCom40 = Array.from( ((new Set(tipoLimiarIds)).add(40)) )
    const amostraIds = tipoAmostraIds.map(amostra => `tiposAmostraIds=${amostra}`).join('&')
    const limiarIds = limiaresCom40.map(limiar => `tiposLimiarIds=${limiar}`).join('&')
    return executar(`api/limiaresByTiposAmostraAndTiposAndIdParametroAnalise.json?${amostraIds}&${limiarIds}&parametroAnaliseId=${parametroId.id}`)
}

const EstradasSimplificada = async () => {
    return executar(`resources/layers/estradasSimplificada.geojson`)
}

const RedesDeDrenagemSimplificada = function() {
    let cacheResponse = null;
    return async () => {
        if (!cacheResponse)
            cacheResponse = await RedesDeDrenagemSimplificada_original()
        return cacheResponse
    }
}()

const RedesDeDrenagemSimplificada_original = async () => {
    return executar(`resources/layers/redesDrenagemSimplificadaComIds.geojson`)
}

const UnidadesConservacao = async () => {
    return executar(`resources/layers/unidadesConservacao.geojson`)
}

const TerrasIndigenas = async () => {
    return executar(`resources/layers/terrasIndigenas.geojson`)
}

const Minas = async () => {
    return executar(`resources/layers/minas.geojson`)
}

const TiposLimiaresBySerieAnaliseAndIdParametroAnaliseAndIdUnidadeParametroAnalise = async (idParametroAnalise, idSerieAnalise, idUnidadeParametroAnalise) => {
    const paramUnidade = idUnidadeParametroAnalise ? `&idUnidadeParametroAnalise=${idUnidadeParametroAnalise}` : ''
    const params = `idSerieAnalise=${idSerieAnalise}&idParametroAnalise=${idParametroAnalise}${paramUnidade}`
    return executar(`tiposLimiaresBySerieAnaliseAndIdParametroAnaliseAndIdUnidadeParametroAnalise.json?${params}`)
}

const LimiaresAmostras = async (idParametroAnalise, idSerieAnalise, idUnidadeParametroAnalise, limiares) => {
    const limiaresIds = limiares.map(limiar => `tiposLimiarIds%5B%5D=${limiar.id}`).join('&')
    const unidade = idUnidadeParametroAnalise ? `&unidadeParametroAnaliseId=${idUnidadeParametroAnalise}` : ""
    const params = `mostrarPontosDeMonitoramento=false&mostrarDuplicatas=false&serieAnaliseId=${idSerieAnalise}&parametroAnaliseId=${idParametroAnalise}${unidade}&${limiaresIds}`
    return executar(`limiaresAmostras.geojson?${params}`)
}

const AmostraValidaByTipoAmostra = async (serie) => {
    return executar(`api/amostraValidaByTipoAmostra?serie=${serie}`)
}

const Geologia = async () => {
    return executar(`resources/layers/geologia.geojson`)
}

const ShapeAnaliseSolo = async (idParametroAnalise, idSerieAnalise) => {
    return executar(`shapeAnaliseSolo.geojson?idParametroAnalise=${idParametroAnalise}&idSerieAnalise=${idSerieAnalise}`)
}

const GrupoAnaliseSolo = async (idParametroAnalise, idSerieAnalise) => {
    return executar(`gruposAnaliseSolo.json?idParametroAnalise=${idParametroAnalise}&idSerieAnalise=${idSerieAnalise}`)
}

const ShapeAnaliseContrasteSolo = async (idParametroAnalise, idSerieAnalise) => {
    return executar(`shapeAnaliseContrasteSolo.geojson?idParametroAnalise=${idParametroAnalise}&idSerieAnalise=${idSerieAnalise}`)
}

const GruposAnaliseContrasteSolo = async (idParametroAnalise, idSerieAnalise) => {
    return executar(`gruposAnaliseContrasteSolo.json?idParametroAnalise=${idParametroAnalise}&idSerieAnalise=${idSerieAnalise}`)
}

const executar = async (url) => {
    const response = await fetch(`${apiUrl}/${url}`, 
    { method: 'GET',  credentials: "include", cacheTime: 0})
    return tratarRetorno(response)
}

const tratarRetorno = async (response) => {
    if (response.status === 200) {
        const json = await response.json()
        return json
    } 
    // else {
    //     navigate("/login")
    //     document.location.reload(true)
    // }
}

export {
    LoginBG,
    Logout,
    ParametrosAnalise,
    DadosSeriesAnaliseByIdParametroAnaliseComUnidade,
    Grids,
    MicrobaciasSimplificada_000100,
    MapAnalysesByAmostraTypeAndParametroAnaliseAndSerieAnalise,
    ChartsDataDistribution,
    ChartsDataCountSerieCampanha,
    EstradasSimplificada,
    RedesDeDrenagemSimplificada,
    UnidadesConservacao,
    TerrasIndigenas,
    Minas,
    TiposLimiaresBySerieAnaliseAndIdParametroAnaliseAndIdUnidadeParametroAnalise,
    LimiaresAmostras,
    AmostraValidaByTipoAmostra,
    Geologia,
    LimiaresParaOsGraficos,
    ShapeAnaliseSolo,
    GrupoAnaliseSolo,
    ShapeAnaliseContrasteSolo,
    GruposAnaliseContrasteSolo
}